import { render, staticRenderFns } from "./wapper.vue?vue&type=template&id=6544085e&scoped=true"
import script from "./wapper.vue?vue&type=script&setup=true&lang=js"
export * from "./wapper.vue?vue&type=script&setup=true&lang=js"
import style0 from "./wapper.vue?vue&type=style&index=0&id=6544085e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6544085e",
  null
  
)

export default component.exports